import { useMemo, useEffect, useState } from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

export function useScrollArrowsForContainer(ref: any, style: string) {
  const [containerScrollLeft, setContainerScrollLeft] = useState(0);

  return useMemo(
    () => (
      <div className={clsx([styles.scrollArrowsContainer, style])}>
        <div
          className={styles.scrollArrow}
          onClick={() => {
            setContainerScrollLeft(
              ref.current?.scrollLeft - ref.current?.clientWidth
            );
            ref.current?.scrollBy({
              left: -1 * ref.current?.clientWidth,
              behavior: 'smooth',
            });
          }}
        >
          <svg
            width="41"
            height="18"
            viewBox="0 0 41 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.351473 10.0118C-0.117157 9.54318 -0.117157 8.78338 0.351473 8.31475L7.98823 0.678C8.45685 0.209373 9.21665 0.209373 9.68528 0.678C10.1539 1.14663 10.1539 1.90643 9.68528 2.37506L4.09705 7.96328L40.1999 7.96328V10.3633L4.09705 10.3633L9.68528 15.9515C10.1539 16.4201 10.1539 17.1799 9.68528 17.6485C9.21665 18.1172 8.45685 18.1172 7.98823 17.6485L0.351473 10.0118Z"
              fill={containerScrollLeft <= 0 ? '#C7C5C1' : '#524E47'}
            />
          </svg>
        </div>

        <div
          className={styles.scrollArrow}
          onClick={() => {
            setContainerScrollLeft(
              ref.current?.scrollLeft + ref.current?.clientWidth
            );
            ref.current?.scrollBy({
              left: ref.current?.clientWidth,
              behavior: 'smooth',
            });
          }}
        >
          <svg
            width="41"
            height="18"
            viewBox="0 0 41 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M40.0489 7.98823C40.5175 8.45685 40.5175 9.21665 40.0489 9.68528L32.4122 17.322C31.9435 17.7907 31.1837 17.7907 30.7151 17.322C30.2465 16.8534 30.2465 16.0936 30.7151 15.625L36.3033 10.0368L0.20039 10.0368V7.63675L36.3033 7.63675L30.7151 2.04853C30.2465 1.5799 30.2465 0.820103 30.7151 0.351473C31.1837 -0.117157 31.9435 -0.117157 32.4122 0.351473L40.0489 7.98823Z"
              fill={
                containerScrollLeft >=
                ref.current?.scrollWidth - ref.current?.clientWidth
                  ? '#C7C5C1'
                  : '#524E47'
              }
            />
          </svg>
        </div>
      </div>
    ),
    [ref, containerScrollLeft]
  );
}
